export const APPLY_PROMO_REQUEST = "APPLY_PROMO_REQUEST";
export const APPLY_PROMO_SUCCESS = "APPLY_PROMO_SUCCESS";
export const APPLY_PROMO_FAIL = "APPLY_PROMO_FAIL";
export const CLEAR_PROMO = "CLEAR_PROMO";